import { render, staticRenderFns } from "./UserNewInModal.vue?vue&type=template&id=180040b8&scoped=true&"
import script from "./UserNewInModal.vue?vue&type=script&lang=js&"
export * from "./UserNewInModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180040b8",
  null
  
)

export default component.exports